/** Ім'я нового тега (UIUX/field-types/tags; прототип createTag): без пробілів по краях і роздільників , ;, пробіли → «-», малими літерами. */
export function normalizeTagName(raw: string): string {
  return raw.replace(/[,;]+/g, ' ').trim().replace(/\s+/g, '-').toLowerCase();
}
